// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xbrmoojcdbtkwlnwkvrk.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhicm1vb2pjZGJ0a3dsbndrdnJrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE0Mjk5NTgsImV4cCI6MjA2NzAwNTk1OH0.BViJMVvgwVM10sqI_VHv0WvuSseU2FlvD_NOxSXoSn0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);